import script from "./PanelConfigurationView.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelConfigurationView.vue?vue&type=script&setup=true&lang=js"

import "./PanelConfigurationView.vue?vue&type=style&index=0&id=0792c834&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0792c834"]])

export default __exports__